var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin__settings container"},[_c('span',[_vm._v("This page is under construction. "),_c('br'),_vm._v("Coming soon...")])])}]

export { render, staticRenderFns }